import { render, staticRenderFns } from "./EditReminderWorkflow.vue?vue&type=template&id=a6f01cba&scoped=true&"
import script from "./EditReminderWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditReminderWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditReminderWorkflow.vue?vue&type=style&index=0&id=a6f01cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f01cba",
  null
  
)

component.options.__file = "EditReminderWorkflow.vue"
export default component.exports